import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import { faLinkHorizontalSlash } from '@fortawesome/pro-solid-svg-icons';

import Tooltip from 'components/tooltip';

interface Props {
  record?: {
    label?: string;
    path: string;
  };
  recordTypeLabel: string;
  onAdd: () => void;
  onRemove: () => void;
}

export default function CrmAssociationLink({ record, recordTypeLabel, onAdd, onRemove }: Props) {
  if (record) {
    return (
      <div>
        <Tooltip content={record.label} dark>
          <a className="me-1" href={record.path}>
            View connected {recordTypeLabel}
          </a>
        </Tooltip>
        <Tooltip content={`Disconnect ${recordTypeLabel}`} dark>
          <a className="clickable" onClick={onRemove}>
            <FontAwesomeIcon icon={faLinkHorizontalSlash} />
          </a>
        </Tooltip>
      </div>
    );
  } else {
    return (
      <a className="clickable" onClick={onAdd}>
        <FontAwesomeIcon className="me-1" icon={faCirclePlus} />
        Connect a {recordTypeLabel}
      </a>
    );
  }
}
